import type { CloudOption } from '@labrav/react-components'

export const flyoutCloudAccountOptions: CloudOption[] = [
  {
    name: 'AWS',
    disabled: false,
  },
  {
    name: 'AZURE',
    disabled: false,
  },
  {
    name: 'GCP',
    disabled: true,
  },
]

export const cloudTypes = [
  {
    name: 'AWS',
    disabled: false,
  },
  {
    name: 'AZURE',
    disabled: true,
  },
  {
    name: 'GCP',
    disabled: true,
  },
]

export const cloudNames = ['aws', 'azure', 'gcp', 'redhat']
